package navigation.home.edititinerary

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.currentOrThrow
import cafe.adriel.voyager.transitions.SlideTransition
import com.essntl.components.sidepanel.SidePanel
import com.essntl.components.sidepanel.SizeConstraint
import com.essntl.components.sidepanel.Splitter
import com.essntl.components.sidepanel.rememberSidePanelState
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.AddEditClientDialog
import com.essntl.features.client.ui.SelectClientDialog
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.client.ui.allclients.AllClientsEvent
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryScreen
import com.essntl.features.itinerary.ui.edit_itinerary.MessageSendType
import com.essntl.features.itinerary.ui.edit_itinerary.components.SelectTravelAgentPopup
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceNavigation
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.AddEditTaskPopup
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.ContactDetailsDialog
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewEvent
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewNavigation
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewScreen
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.task.ui.addedittask.AddEditTaskEvent
import essntl.key.LocalKeyEventManager
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.link.NavLinkState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.launch
import navigation.home.address.AddressScreenModel
import navigation.home.clients.addeditclient.AddEditClientScreenModel
import navigation.home.clients.allclients.AllClientsScreenModel
import navigation.home.contact.ContactScreenModel
import navigation.home.customfields.CustomFieldsScreenModel
import navigation.home.edititineraryservice.EditItineraryServiceScreenModel
import navigation.home.edititineraryservice.EditItineraryServiceScreenNav
import navigation.home.invoice.addeditinvoice.AddEditInvoiceScreenNav
import navigation.home.invoice.allinvoice.AllInvoiceScreenModel
import navigation.home.itineraryoverview.ItineraryOverviewScreenModel
import navigation.home.organization.OrganizationScreenModel
import navigation.home.proposal.addeditproposal.AddEditProposalScreenNav
import navigation.home.proposal.selectservice.SelectServiceScreenModel
import navigation.home.send_message.SendMessageScreenNav
import navigation.home.service.addeditservice.AddEditServiceScreenModel
import navigation.home.suppliers.allsuppliers.AllSuppliersScreenModel
import navigation.home.task.addedittask.AddEditTaskScreenModel
import navigation.utils.NavLinkScreen
import navigation.utils.safePop
import navigation.utils.safePush
import navigation.utils.safeReplaceAll
import org.koin.core.qualifier.named

class EditItineraryScreenNav(
    val itineraryId: String = "",
) : NavLinkScreen {
    private val isConcierge = itineraryId.isEmpty()

    override val defaultTitle: String =
        if (isConcierge) {
            "Concierge"
        } else {
            "Edit Itinerary"
        }

    override var navLinkState: NavLinkState by mutableStateOf(
        NavLinkState(
            title = defaultTitle,
            isLoading = !isConcierge,
            iconRes =
                if (isConcierge)
                    EsIcons.Concierge else
                    EsIcons.Itinerary,
        ),
    )

    override val key: ScreenKey = "EditItineraryScreenNav/$itineraryId"

    @Composable
    override fun Content() {
        val editItineraryScreenModel = koinScreenModel<EditItineraryScreenModel>()
        val editItineraryState by editItineraryScreenModel.state.collectAsState()

        val organizationScreenModel = koinScreenModel<OrganizationScreenModel>()
        val organizationState by organizationScreenModel.state.collectAsState()

        val contactScreenModel = koinScreenModel<ContactScreenModel>(named("supplier"))
        val contactState by contactScreenModel.state.collectAsState()

        val taContactScreenModel = koinScreenModel<ContactScreenModel>(named("travelAgent"))
        val taContactState by taContactScreenModel.state.collectAsState()

        val organizationAddressScreenModel = koinScreenModel<AddressScreenModel>(named("organization"))
        val organizationAddressState by organizationAddressScreenModel.state.collectAsState()

        val contactAddressScreenModel = koinScreenModel<AddressScreenModel>(named("contact"))
        val contactAddressState by contactAddressScreenModel.state.collectAsState()

        val customFieldsScreenModel = koinScreenModel<CustomFieldsScreenModel>()
        val customFieldsState by customFieldsScreenModel.state.collectAsState()

        val invoiceScreenModel = koinScreenModel<AllInvoiceScreenModel>()
        val invoiceState by invoiceScreenModel.state.collectAsState()

        val editItineraryServiceScreenModel = koinScreenModel<EditItineraryServiceScreenModel>()
        val editItineraryServiceState by editItineraryServiceScreenModel.state.collectAsState()

        val selectServiceScreenModel = koinScreenModel<SelectServiceScreenModel>()
        val selectServiceState by selectServiceScreenModel.state.collectAsState()

        val addEditServiceScreenModel = koinScreenModel<AddEditServiceScreenModel>()
        val addEditServiceState by addEditServiceScreenModel.state.collectAsState()

        val addEditTaskScreenModel = koinScreenModel<AddEditTaskScreenModel>()
        val addEditTaskState by addEditTaskScreenModel.state.collectAsState()

        val itineraryOverviewScreenModel = koinScreenModel<ItineraryOverviewScreenModel>()
        val itineraryOverviewState by itineraryOverviewScreenModel.state.collectAsState()

        val addEditClientScreenModel = koinScreenModel<AddEditClientScreenModel>()
        val addEditClientState by addEditClientScreenModel.state.collectAsState()

        val allClientScreenModel = koinScreenModel<AllClientsScreenModel>()
        val allClientState by allClientScreenModel.state.collectAsState()
        var isSelectClientDialogOpen by rememberSaveable { mutableStateOf(false) }

        val allSuppliersScreenModel = koinScreenModel<AllSuppliersScreenModel>()
        val allSuppliersState by allSuppliersScreenModel.state.collectAsState()

        var openAddEditClientDialog by rememberSaveable { mutableStateOf(false) }
        var clientToEdit by remember { mutableStateOf<ClientModel?>(null) }

        var isChangeTravelAgentPopupOpen by rememberSaveable { mutableStateOf(false) }
        var isChangeContactPopupOpen by rememberSaveable { mutableStateOf(false) }
        var proposalToEdit by remember { mutableStateOf<ProposalModel?>(null) }

        val navigator = LocalNavigator.currentOrThrow

        var sidePanelNavigator by remember { mutableStateOf<Navigator?>(null) }

        val scope = rememberCoroutineScope()

        val keyEventManager = LocalKeyEventManager.current

        val sidePanelState =
            rememberSidePanelState(
                sidePanelVisible = false,
                panelSizeConstraint =
                    SizeConstraint(
                        minSize = 300.dp,
                        maxSize = 600.dp,
                    ),
            )

        var addTaskItineraryId by rememberSaveable {
            mutableStateOf<String?>(null)
        }

        var addTaskItineraryServiceId by rememberSaveable {
            mutableStateOf<String?>(null)
        }

        var editTaskId by rememberSaveable {
            mutableStateOf<String?>(null)
        }

        var itineraryServices by remember {
            mutableStateOf<List<ItineraryServiceModel>?>(null)
        }

        var messageType by remember {
            mutableStateOf<MessageSendType?>(null)
        }

        LaunchedEffect(keyEventManager) {
            keyEventManager.events.collectLatest {
                if (it.key == Key.H && it.type == KeyEventType.KeyUp) {
                    sidePanelState.sidePanelOpened = false
                }
            }
        }

        LaunchedEffect(sidePanelState.sidePanelOpened) {
            if (!sidePanelState.sidePanelOpened) {
                editItineraryServiceScreenModel.onEvent(
                    EditItineraryServiceEvent.ClearItineraryService,
                )
                editItineraryScreenModel.onEvent(
                    EditItineraryEvent.ClickItineraryService(null),
                )

                sidePanelNavigator = null
            }
        }

        LaunchedEffect(Unit) {
            if (isConcierge) {
                editItineraryScreenModel.onEvent(EditItineraryEvent.GetAllItineraryService)
            } else {
                editItineraryScreenModel.onEvent(EditItineraryEvent.GetItinerary(itineraryId))
            }

            navLinkState = navLinkState.copy(
                onRefresh = {
                    if (isConcierge) {
                        editItineraryScreenModel.onEvent(EditItineraryEvent.GetAllItineraryService)
                    } else {
                        editItineraryScreenModel.onEvent(EditItineraryEvent.GetItinerary(itineraryId))
                    }
                    sidePanelState.sidePanelOpened = false
                },
            )
        }

        LaunchedEffect(addEditTaskState.addEditTask.isSuccess) {
            if (addEditTaskState.addEditTask.isSuccess) {
                addEditTaskScreenModel.onEvent(AddEditTaskEvent.ClearTaskState)

                editTaskId = null
                addTaskItineraryId = null
                addTaskItineraryServiceId = null
            }
        }

        LaunchedEffect(editItineraryState.editProposal.isSuccess) {
            if (editItineraryState.editProposal.isSuccess) {
                editItineraryState.editProposal.data?.let {
                    editItineraryServiceScreenModel.onEvent(
                        EditItineraryServiceEvent.UpdateProposal(it),
                    )
                }
                editItineraryScreenModel.onEvent(EditItineraryEvent.ClearItinerary)
            }
        }

        LaunchedEffect(addEditClientState.addEditClient.isSuccess) {
            if (addEditClientState.addEditClient.isSuccess) {
                addEditClientState.addEditClient.data?.let {
                    if (clientToEdit != null) {
                        editItineraryScreenModel.onEvent(EditItineraryEvent.EditClient(it))
                    } else {
                        editItineraryScreenModel.onEvent(EditItineraryEvent.AddClient(it))
                    }
                }
                addEditClientScreenModel.onEvent(AddEditClientEvent.ClearClientState)
                openAddEditClientDialog = false
                clientToEdit = null
            }
        }

        LaunchedEffect(editItineraryState.addEditProposal.isSuccess) {
            if (editItineraryState.addEditProposal.isSuccess) {
                editItineraryScreenModel.onEvent(EditItineraryEvent.ClearProposalState)
                isChangeTravelAgentPopupOpen = false
                isChangeContactPopupOpen = false
                proposalToEdit = null
            }
        }

        LaunchedEffect(editItineraryServiceState.getItineraryService) {
            val service = editItineraryServiceState.getItineraryService.data?.service
            if (service != null)
                editItineraryServiceScreenModel.onEvent(
                    EditItineraryServiceEvent.GetSuppliers(service = service),
                )
        }

        LaunchedEffect(editItineraryState.getAllItineraryService) {
            editItineraryScreenModel.onEvent(EditItineraryEvent.GetItineraryServicesMessages)
        }

        if (!isConcierge) {
            LaunchedEffect(editItineraryState.getAllItinerary) {
                val title = editItineraryState.getAllItinerary.data?.firstOrNull()?.proposal?.title

                navLinkState =
                    if (title != null) {
                        navLinkState.copy(
                            title = title,
                            isLoading = false,
                        )
                    } else {
                        navLinkState.copy(
                            isLoading = editItineraryState.getAllItinerary.isLoading,
                        )
                    }
            }
        }

        SidePanel(
            sidePanelState = sidePanelState,
            isHorizontal = true,
            sidePanel = {
                Box(
                    modifier =
                        Modifier
                            .fillMaxSize(),
                ) {
                    if (itineraryOverviewState.getItinerary.data != null) {
                        Column(
                            modifier =
                                Modifier
                                    .fillMaxHeight()
                                    .padding(end = 1.5f.spacing)
                                    .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween,
                                modifier =
                                    Modifier
                                        .background(MaterialTheme.esColorScheme.bgSecondary)
                                        .padding(2.5f.spacing)
                                        .fillMaxWidth(),
                            ) {
                                EsMediumOutlineIconButton(
                                    onClick = {
                                        sidePanelState.sidePanelOpened = false
                                        itineraryOverviewScreenModel.onEvent(
                                            ItineraryOverviewEvent.ClearState,
                                        )
                                    },
                                    iconRes = EsIcons.ArrowRight,
                                )

                                Spacer(modifier = Modifier.width(2.5f.spacing))

                                SelectionContainer {
                                    Text(
                                        text = itineraryOverviewState.getItinerary.data?.proposal?.title ?: "",
                                        color = MaterialTheme.esColorScheme.textPrimary,
                                        style = MaterialTheme.esTypography.h3Bold24,
                                        overflow = TextOverflow.Ellipsis,
                                        maxLines = 1,
                                        textAlign = TextAlign.End,
                                        modifier = Modifier.weight(1f),
                                    )
                                }
                            }

                            ItineraryOverviewScreen(
                                state = itineraryOverviewState,
                                invoiceState = invoiceState,
                                onInvoiceEvent = invoiceScreenModel::onEvent,
                                onNavigation = { event ->
                                    when (event) {
                                        is ItineraryOverviewNavigation.EditItinerary -> {
                                            navigator.safePush(
                                                EditItineraryScreenNav(
                                                    itineraryId = event.itineraryId,
                                                ),
                                            )
                                        }


                                        is ItineraryOverviewNavigation.EditInvoice -> {
                                            navigator.safePush(
                                                AddEditInvoiceScreenNav(
                                                    proposalId = event.proposalId,
                                                    invoiceId = event.invoiceId,
                                                ),
                                            )
                                        }

                                        is ItineraryOverviewNavigation.AddInvoice -> {
                                            navigator.safePush(
                                                AddEditInvoiceScreenNav(
                                                    proposalId = event.proposalId,
                                                ),
                                            )
                                        }
                                    }
                                },
                            )
                        }
                    } else {
                        Navigator(LoaderScreenNav()) { navigator ->
                            LaunchedEffect(navigator) {
                                sidePanelNavigator = navigator
                            }

                            Column(
                                modifier = Modifier
                                    .background(
                                        color = MaterialTheme.esColorScheme.bgSecondary,
                                        shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
                                    )
                                    .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                                    .fillMaxSize(),
                            ) {
                                EsMediumOutlineIconButton(
                                    onClick = {
                                        if (navigator.canPop)
                                            navigator.pop() else
                                            sidePanelState.sidePanelOpened = false
                                    },
                                    iconRes = if (navigator.canPop)
                                        EsIcons.ArrowLeft else
                                        EsIcons.ArrowRight,
                                    modifier = Modifier.padding(2.5f.spacing),
                                )

                                SlideTransition(navigator)
                            }
                        }
                    }
                }
            },
            splitter =
                Splitter(
                    measuredPart = {
                        Box(
                            modifier =
                                Modifier
                                    .width(1.spacing)
                                    .fillMaxHeight(),
                        )
                    },
                ),
            modifier =
                Modifier
                    .fillMaxSize(),
        ) {
            EditItineraryScreen(
                isConcierge = isConcierge,
                state = editItineraryState,
                onEvent = editItineraryScreenModel::onEvent,
                contactState = contactState,
                contactEvent = contactScreenModel::onEvent,
                selectServiceState = selectServiceState,
                addEditServiceValidation = addEditServiceScreenModel.validation,
                addEditServiceEvent = addEditServiceScreenModel::onEvent,
                addEditServiceState = addEditServiceState,
                selectServiceEvent = selectServiceScreenModel::onEvent,
                allSuppliersState = allSuppliersState,
                onEventAllSuppliers = allSuppliersScreenModel::onEvent,
                invoiceState = invoiceState,
                onInvoiceEvent = invoiceScreenModel::onEvent,
                onNavigation = {
                    when (it) {
                        is EditItineraryNavigation.NavigateBack -> {
                            navigator.safePop(this@EditItineraryScreenNav)
                        }

                        is EditItineraryNavigation.EditItineraryService -> {
                            itineraryOverviewScreenModel.onEvent(
                                ItineraryOverviewEvent.ClearState,
                            )

                            itineraryServices = null
                            messageType = null

                            it.itineraryService.itineraryId?.let { itineraryId ->

                                sidePanelState.sidePanelOpened = true

                                scope.launch {
                                    while (sidePanelNavigator == null) {
                                        delay(10)
                                    }

                                    sidePanelNavigator?.safeReplaceAll(
                                        EditItineraryServiceScreenNav(
                                            itineraryServiceId = it.itineraryService.id,
                                            itineraryId = itineraryId,
                                            onNavigation = {
                                                when (it) {
                                                    is EditItineraryServiceNavigation.NavigateBack -> {
                                                        sidePanelState.sidePanelOpened = false
                                                    }

                                                    is EditItineraryServiceNavigation.AddItineraryServiceTask -> {
                                                        editTaskId = null
                                                        addTaskItineraryId = null
                                                        addTaskItineraryServiceId = it.itineraryServiceId

                                                        addEditTaskScreenModel.onEvent(
                                                            AddEditTaskEvent.GetItineraryService(
                                                                itineraryServiceId = it.itineraryServiceId,
                                                            ),
                                                        )
                                                    }

                                                    is EditItineraryServiceNavigation.EditTask -> {
                                                        editTaskId = it.taskId
                                                        addTaskItineraryId = null
                                                        addTaskItineraryServiceId = null

                                                        addEditTaskScreenModel.onEvent(AddEditTaskEvent.GetTask(it.taskId))
                                                    }

                                                    else -> {}
                                                }
                                            },
                                            onSuccessMessage = {
                                                sidePanelState.sidePanelOpened = false
                                            }
                                        ),
                                    )
                                }

                                editItineraryScreenModel.onEvent(
                                    EditItineraryEvent.ClickItineraryService(it.itineraryService.id),
                                )
                            }
                        }

                        is EditItineraryNavigation.GetItinerary -> {
                            editItineraryServiceScreenModel.onEvent(
                                EditItineraryServiceEvent.ClearItineraryService,
                            )

                            itineraryOverviewScreenModel.onEvent(
                                ItineraryOverviewEvent.GetItinerary(it.itineraryService.itineraryId ?: ""),
                            )
                            sidePanelState.sidePanelOpened = true
                        }

                        is EditItineraryNavigation.AddItineraryTask -> {
                            editTaskId = null
                            addTaskItineraryId = it.itineraryId.id
                            addTaskItineraryServiceId = null

                            addEditTaskScreenModel.onEvent(
                                AddEditTaskEvent.GetItinerary(it.itineraryId, it.proposalId),
                            )
                        }

                        is EditItineraryNavigation.EditTask -> {
                            editTaskId = it.taskId
                            addTaskItineraryId = null
                            addTaskItineraryServiceId = null

                            addEditTaskScreenModel.onEvent(AddEditTaskEvent.GetTask(it.taskId))
                        }

                        is EditItineraryNavigation.AddClient -> {
                            openAddEditClientDialog = true
                        }

                        is EditItineraryNavigation.SelectClient -> {
                            isSelectClientDialogOpen = true
                        }

                        is EditItineraryNavigation.EditClient -> {
                            clientToEdit = it.client
                            openAddEditClientDialog = true
                        }

                        is EditItineraryNavigation.ChangeTravelAgent -> {
                            proposalToEdit = it.proposal
                            isChangeTravelAgentPopupOpen = true
                        }

                        is EditItineraryNavigation.EditTravelAgent -> {
                            proposalToEdit = it.proposal
                            isChangeContactPopupOpen = true
                        }

                        is EditItineraryNavigation.SendMessage -> {
                            editItineraryServiceScreenModel.onEvent(
                                EditItineraryServiceEvent.ClearItineraryService,
                            )

                            itineraryServices = it.itineraryServices
                            messageType = it.type

                            if (!itineraryServices.isNullOrEmpty() &&
                                messageType != null
                            ) {
                                sidePanelState.sidePanelOpened = true

                                scope.launch {
                                    while (sidePanelNavigator == null) {
                                        delay(10)
                                    }

                                    sidePanelNavigator?.safeReplaceAll(
                                        SendMessageScreenNav(
                                            itineraryId = itineraryServices.orEmpty().firstOrNull()?.itineraryId
                                                ?: itineraryId,
                                            itineraryServices = itineraryServices.orEmpty(),
                                            type = messageType ?: MessageSendType.CLIENT,
                                            onSuccessMessage = {
                                                sidePanelState.sidePanelOpened = false
                                            },
                                        ),
                                    )
                                }

                                editItineraryScreenModel.onEvent(
                                    EditItineraryEvent.ClickItineraryService(null),
                                )
                            }
                        }

                        is EditItineraryNavigation.EditInvoice -> {
                            navigator.push(
                                AddEditInvoiceScreenNav(
                                    invoiceId = it.invoiceId,
                                    proposalId = it.proposalId,
                                    itineraryId = it.itineraryId,
                                ),
                            )
                        }

                        is EditItineraryNavigation.EditProposal -> {
                            navigator.push(
                                AddEditProposalScreenNav(
                                    proposalId = it.proposalId,
                                ),
                            )
                        }
                    }
                },
            )

            AddEditTaskPopup(
                taskId = editTaskId,
                openDialog = editTaskId != null || addTaskItineraryId != null || addTaskItineraryServiceId != null,
                onDismissRequest = {
                    editTaskId = null
                    addTaskItineraryId = null
                    addTaskItineraryServiceId = null

                    addEditTaskScreenModel.onEvent(AddEditTaskEvent.ClearTaskState)
                },
                state = addEditTaskState,
                onEvent = addEditTaskScreenModel::onEvent,
                validation = addEditTaskScreenModel.validation,
            )

            AddEditClientDialog(
                openDialog = openAddEditClientDialog,
                currentClient = clientToEdit,
                state = addEditClientState,
                onEvent = addEditClientScreenModel::onEvent,
                validation = addEditClientScreenModel.validation,
                onDismissRequest = {
                    openAddEditClientDialog = false
                    clientToEdit = null
                },
            )

            SelectTravelAgentPopup(
                isOpen = isChangeTravelAgentPopupOpen,
                contactState = contactState,
                contactEvent = contactScreenModel::onEvent,
                isLoading = editItineraryState.addEditProposal.isLoading,
                selectedTravelAgent = proposalToEdit?.travelAgent,
                onDismissRequest = {
                    isChangeTravelAgentPopupOpen = false
                    proposalToEdit = null
                    contactScreenModel.onEvent(ContactEvent.ClearContactState)
                },
                onChangeTravelAgent = {
                    proposalToEdit?.let { proposal ->
                        editItineraryScreenModel.onEvent(
                            EditItineraryEvent.UpdateProposal(
                                proposal.copy(travelAgent = it),
                            ),
                        )
                    }
                },
            )

            ContactDetailsDialog(
                isOpen = isChangeContactPopupOpen,
                onDismissRequest = {
                    isChangeContactPopupOpen = false
                    proposalToEdit = null
                },
                type = OrganizationModel.Type.TravelAgency,
                contact = proposalToEdit?.travelAgent?.contact,
                organizationState = organizationState,
                organizationEvent = organizationScreenModel::onEvent,
                organizationValidation = organizationScreenModel.validation,
                organizationAddressState = organizationAddressState,
                organizationAddressEvent = organizationAddressScreenModel::onEvent,
                organizationAddressValidation = organizationAddressScreenModel.validation,
                state = taContactState,
                onEvent = taContactScreenModel::onEvent,
                validation = taContactScreenModel.validation,
                addressState = contactAddressState,
                onAddressEvent = contactAddressScreenModel::onEvent,
                addressValidation = contactAddressScreenModel.validation,
                customFieldsState = customFieldsState,
                onCustomFieldsEvent = customFieldsScreenModel::onEvent,
                isSaveEnabled = taContactScreenModel.vm.isContactChanged() ||
                    contactAddressScreenModel.vm.isAddressChanged() ||
                    customFieldsScreenModel.vm.isCustomFieldsChanged(),
                onEditTravelAgent = {
                    proposalToEdit?.let { proposal ->
                        editItineraryScreenModel.onEvent(
                            EditItineraryEvent.UpdateProposal(
                                proposal,
                            ),
                        )
                    }
                },
            )

            SelectClientDialog(
                isOpen = isSelectClientDialogOpen,
                onDismissRequest = {
                    isSelectClientDialogOpen = false
                },
                getAllClients = allClientState.getAllClients,
                onLoadMoreClient = {
                    allClientScreenModel.onEvent(AllClientsEvent.LoadClients())
                },
                onSearchTextChange = {
                    allClientScreenModel.onEvent(AllClientsEvent.SearchClient(it))
                },
                onSelectClient = { client ->
                    isSelectClientDialogOpen = false
                    addEditClientScreenModel.onEvent(AddEditClientEvent.UpdateClientFields(client))
                    addEditClientScreenModel.onEvent(AddEditClientEvent.AddClient)
                },
            )
        }
    }
}